import { createUseStyles } from 'react-jss';
import { AlertChildrenProps, AlertProps } from '.';
import { PRIMARY_STATUS_COLORS, SECONDARY_STATUS_COLORS } from '@tcl-argon-utils/utils';
import { Classes } from 'jss';
import { GrayscalePalette, ActionPalette } from '@tcl-boron-colors/colors';

export const useAlertStyles: (
  data?: AlertProps & {
    theme?: Jss.Theme;
  },
) => Classes<'root' | 'dismissButton'> = createUseStyles({
  root: {
    backgroundColor: ({ status = 'default' }: AlertProps) => SECONDARY_STATUS_COLORS[status],
    boxShadow: `0px 1px 3px 1px ${GrayscalePalette[300]}`,
    display: 'inline-flex',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '14px',
    maxWidth: '650px',
    padding: '18px 16px 18px 24px',
    position: 'relative',
    boxSizing: 'border-box',
    borderRadius: '8px',
  },
  dismissButton: {
    flexShrink: 0,
    background: 'transparent',
    cursor: 'pointer',
    width: '32px',
    height: '32px',
    padding: '0',
    position: 'absolute',
    right: '7px',
    top: '9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
    border: '3px solid transparent',
    borderRadius: '50%',
    '&:focus-visible': {
      border: `3px solid ${ActionPalette[300]}`,
    },
  },
});

export const useAlertChildrenStyles = createUseStyles({
  icon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    color: ({ status }: AlertChildrenProps) => PRIMARY_STATUS_COLORS[status],
    marginRight: '16px',
  },
  title: {
    flexShrink: 0,
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '14px',
    marginRight: '24px',
  },
  content: {
    flex: '1 1 auto',
    fontSize: '14px',
    lineHeight: '14px',
    whiteSpace: 'nowrap',
    marginRight: ({ children, isDismissable }: AlertChildrenProps) =>
      isDismissable || children.action !== null ? '48px' : '',
  },
  action: {
    flexShrink: 0,
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '14px',
    borderRadius: '3px',
    marginRight: ({ isDismissable }: AlertChildrenProps) => (isDismissable ? '16px' : undefined),
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    '&:focus-visible': {
      outline: `3px solid ${ActionPalette[300]}`,
    },
  },
  dismissButtonSpacer: {
    flexShrink: 0,
    width: '14px',
  },
});
